// src/components/Form/SelectAsync.js
import React, { useRef, useEffect, useState } from 'react';
import Select, { Props as AsyncProps } from 'react-select/async';
import { useField } from '@unform/core';
// import { mensagemErro } from './../Layout'
import api from './../../api'

function SelectAsync({ name, col, titulo, router, routerParams = {}, labelValue = '', ...props }) {
    const selectRef = useRef(null);
    const { fieldName, defaultValue, registerField, error } = useField(name);
    const [textSelecionad, setTextSelecionado] = useState('')

    useEffect(() => {
        registerField({
            name: fieldName,
            ref: selectRef.current,
            path: 'select.state.value',
            getValue: (ref) => {
                if (props.isMulti) {
                    if (!ref.select.state.value) {
                        return [];
                    }

                    return ref.select.state.value.map(
                        (option) => option.value,
                    );
                } else {
                    if (!ref.select.state.value) {
                        return '';
                    }

                    return ref.select.state.value.value;
                }
            },
            setValue: (ref, value) => {
                ref.select.select.setValue(value);
            }
        });
    }, [fieldName, registerField, props.isMulti]);

    async function onSearchData(seachText) {

        if (router) {

            const resp = await api.post(router, {
                text: seachText,
                params: routerParams
            })

            if (resp.data.type === 2) {

                console.clear()
                console.log(resp.data.value)

                return
            }

            if (resp.status === 200) {
                return resp.data.value
            }
            else {
                return []
            }
        }
    }

    return (
        <div className={`cInputD selectD ${col}`} classID={labelValue}>
            <span>{titulo}</span>
            <Select
                cacheOptions
                defaultValue={defaultValue}
                ref={selectRef}
                classNamePrefix="react-select"
                placeholder='Selecionar'
                noOptionsMessage={() => 'Sem dados'}
                loadOptions={onSearchData}
                defaultOptions
                {...props}
            />
            {error && <span className="error-validacao">{error}</span>}
        </div>
    );
};

export default SelectAsync;